import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Horaires from "./Horaires";
import Photo from "./Photo";
import Reveal from "./Reveal";
import useI18n from "@/i18n";

export default function Lieu() {
    const { t, to } = useI18n();

    return (
        <section id="lieu" className="grad-up scroll-mt-24 py-16 md:py-24" data-testid="lieu-section">
            <div className="mx-auto max-w-[1080px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.lieu.eyebrow}</p>
                    <h2 className="text-3xl text-terrat md:text-4xl">{t.lieu.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[52ch] text-lg text-ink2">{t.lieu.lead}</p>
                </Reveal>
                <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    {t.lieu.photos.map(([file, alt, legend], i) => (
                        <Reveal key={file} delay={0.05 + i * 0.07}>
                            <Photo
                                file={file}
                                alt={alt}
                                legend={legend}
                                position={file === "bureau.jpg" ? "50% 45%" : "50% 50%"}
                                ratioClass="aspect-[6/5] rounded-[18px]"
                            />
                        </Reveal>
                    ))}
                </div>
                <Reveal>
                    <div className="mt-8" data-testid="lieu-horaires">
                        <Horaires compact />
                    </div>
                </Reveal>
                <Reveal>
                    <Link
                        to={to("cabinet")}
                        className="link-underline mt-8 inline-flex items-center gap-1.5 text-sm font-bold text-terrat"
                        data-testid="lieu-detail-link"
                    >
                        {t.lieu.detailLink}
                        <ArrowRight size={14} aria-hidden="true" />
                    </Link>
                </Reveal>
            </div>
        </section>
    );
}
